import {
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList
} from '@angular/core';
import _ from 'lodash';
import { SelectItem, LazyLoadEvent } from 'primeng/api';
import { MultiSelect } from 'primeng/multiselect';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TabName } from '../../../models/_enum-collections';
import { EngagementEditInput } from '../../../models/engagement-edit-input.model';
import { MSAIExceptionDisputeRequests } from '../../../models/msai-exception-dispute-requests.model';
import { MSAIExceptionDisputeSearchAndFilterInput } from '../../../models/msai-exception-dispute-search-and-filter-input.model';
import { MsaipAction } from '../../../models/msaip-action.model';
import { MsaipExceptionDisputeStatus } from '../../../models/msaip-exception-dispute-status.model';
import { MsaipRequestReason } from '../../../models/msaip-request-reason.model';
import { AppConstants } from '../../common/app-constants';
import { CommonSharedModule } from '../../common/shared.module';
import { EditComponent } from '../../home/edit/edit.component';
import { LocalStorageService } from '../../services/local-storage-service';
import { OsmosisEditService } from '../../services/osmosis-edit.service';
import { OsmosisService } from '../../services/osmosis.service';

@Component({
  selector: 'app-exception-dispute-requests',
  templateUrl: './exception-dispute-requests.component.html',
  styleUrls: ['./exception-dispute-requests.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class ExceptionDisputeRequestsComponent implements OnInit {
  @ViewChild('editNavChild', { static: false }) editNavChild!: EditComponent;
  @ViewChild('dt', { static: false }) dt!: Table;
  @ViewChildren('tak') components!: QueryList<MultiSelect>;

  constructor(
    private osm: OsmosisService,
    private osmEdit: OsmosisEditService,
    public localStorage: LocalStorageService
  ) {}

  get isProdEnvironment(): boolean {
    return environment.isProdEnvironment;
  }

  pmos!: MSAIExceptionDisputeRequests[];
  partnerInputs: MSAIExceptionDisputeRequests[] = [];
  pmo!: MSAIExceptionDisputeRequests;

  scrollableCols!: any[];
  frozenCols!: any[];
  globalFilterCols!: any[];
  excelLoading = false;

  currentPageInfo!: string;
  loadingIcon = 'fa-circle-o-notch';
  totalRecords!: number;
  tblPageNumber!: number;
  recPerPage!: number;
  display!: boolean;
  loading = false;
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;

  loadEditComponent = false;
  editNav = false;
  requestDetailId!: number;
  engagementIdPassToChild!: number;
  showFullscreen = false;
  engagementEditInput!: EngagementEditInput;
  searchAndFilterInput: MSAIExceptionDisputeSearchAndFilterInput =
    new MSAIExceptionDisputeSearchAndFilterInput();
  currentSearchSubscription!: Subscription;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  delayedLoadSearchContent!: Function;

  msaipActions!: MsaipAction[];
  msaipActionsDrpdwn: SelectItem[] = [];
  msaipExceptionDisputeStatus!: MsaipExceptionDisputeStatus[];
  msaipExceptionDisputeStatusDrpdwn: SelectItem[] = [];
  msaipRequestReason!: MsaipRequestReason[];
  msaipRequestReasonDrpdwn: SelectItem[] = [];

  ngOnInit() {
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.emptyRecordMsg = AppConstants.emptyRecordMsg;

    this.display = false;
    this.loading = true;
    this.loadEditComponent = false;
    this.editNav = false;
    this.showFullscreen = this.localStorage.getFullscreenMode();
    this.engagementEditInput = {
      showFullScreen: this.showFullscreen
    } as any;
    this.scrollableCols = [
      { field: 'requestType', header: 'Task Owner' },
      { field: 'requestReason', header: 'Request Reason' },
      { field: 'action', header: 'Action' },
      { field: 'requestKey', header: 'Requested Workshop ID' },
      { field: 'workshopName', header: 'Requested Workshop Name' },
      { field: 'customerOrgName', header: 'Customer Org' },
      { field: 'partnerInputParnterName', header: 'Partner Name' },
      { field: 'partnerInputMPNId', header: 'Partner MPNID' },
      { field: 'partnerInputCustomerTPId', header: 'TPID' },
      { field: 'status', header: 'Status' }
    ];

    this.frozenCols = [
      { field: 'msaipExceptionDisputeId', header: 'Exception/Dispute ID' }
    ];

    this.globalFilterCols = [
      'msaipExceptionDisputeId',
      'requestType',
      'requestReason',
      'action',
      'requestKey',
      'workshopName',
      'customerOrgName',
      'partnerInputParnterName',
      'partnerInputMPNId',
      'partnerInputCustomerTPId',
      'status'
    ];
    this.getmsaipActionsDrpdwn();
    this.getMsaipExceptionDisputeStatusDrpdwn();
    this.getMsaipRequestReasonDrpdwn();
    this.delayedLoadSearchContent = _.debounce(this.loadSearchContent, 1000);
    this.resetFiltersAndLoad();
  }

  pageChange() {
    this.computeResultsCountText();
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    this.computeResultsCountText();
  }

  computeResultsCountText() {
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    } else {
      const currentStartCount =
        (this.searchAndFilterInput.page - 1) * this.dataViewRecsPerPage;
      const currentEndCount = currentStartCount + this.dataViewRecsPerPage;
      this.currentPageInfo =
        'Showing ' +
        (currentStartCount + 1) +
        ' - ' +
        (currentEndCount > this.totalRecords
          ? this.totalRecords
          : currentEndCount) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    this.components['_results'].forEach(ds => {
      ds.value = null;
    });

    if (this.dt) {
      this.dt.reset();
    }

    this.display = false;
    this.loading = true;
    this.resetFiltersAndLoad();
  }

  resetFiltersAndLoad() {
    this.searchAndFilterInput = new MSAIExceptionDisputeSearchAndFilterInput();
    this.searchAndFilterInput.pageSize = AppConstants.dataListRecsPerPage;
    this.searchAndFilterInput.page = 1;
    this.searchOrFilterEngagements();
  }

  refresh() {
    this.searchOrFilterEngagements();
  }

  clearSearchText() {
    this.searchAndFilterInput.searchString = '';
    this.searchOrFilterEngagements();
  }

  searchOrFilterEngagements() {
    this.searchAndFilterInput.page = 1;
    if (this.dt) {
      this.dt.first = this.searchAndFilterInput.page;
    }
    this.delayedLoadSearchContent();
  }

  loadSearchContent(event?: LazyLoadEvent) {
    this.loading = true;
    this.searchAndFilterInput.computeFilterListParams();
    if (this.currentSearchSubscription) {
      this.currentSearchSubscription.unsubscribe();
    }
    if (event) {
      this.searchAndFilterInput.page =
        (event.first ?? 0) == 0
          ? 1
          : (event.first ?? 0) / this.dataViewRecsPerPage + 1;

      if (event.sortField) {
        this.searchAndFilterInput.sortField = event.sortField;
        this.searchAndFilterInput.sortOrderDescending =
          event.sortOrder == 1 ? false : true;
      }
    }
    this.searchAndFilterInput.tabName = TabName.AllActivity;
    this.currentSearchSubscription = this.osm
      .searchMSAIExceptionDisputeRequests(this.searchAndFilterInput)
      .subscribe(
        result => {
          this.pmos = result.results;
          this.totalRecords = result.rowCount;
          this.computeResultsCountText();
          this.loading = false;
        },
        () => {
          this.pmos = [];
          this.totalRecords = 0;
          this.loading = false;
          this.computeResultsCountText();
        }
      );
  }

  getmsaipActionsDrpdwn() {
    this.osmEdit.getMsaipActionsDropDown().subscribe(result => {
      this.msaipActions = result;
      for (const item of this.msaipActions) {
        if (!item.isDeleted) {
          const msaipActionsDrpdwn: SelectItem = {
            label: item.name,
            value: item.name
          };
          this.msaipActionsDrpdwn.push(msaipActionsDrpdwn);
        }
      }
    });
  }

  getMsaipExceptionDisputeStatusDrpdwn() {
    this.osmEdit.getmsaipExceptionDisputeStatusDropDown().subscribe(result => {
      this.msaipExceptionDisputeStatus = result;
      for (const item of this.msaipExceptionDisputeStatus) {
        if (!item.isDeleted) {
          const msaipExceptionDisputeStatus: SelectItem = {
            label: item.name,
            value: item.name
          };
          this.msaipExceptionDisputeStatusDrpdwn.push(
            msaipExceptionDisputeStatus
          );
        }
      }
    });
  }

  getMsaipRequestReasonDrpdwn() {
    this.osmEdit.getMsaipRequestReasonDropDown().subscribe(result => {
      let duplicateIndex;

      this.msaipRequestReason = result;
      for (const item of this.msaipRequestReason) {
        if (!item.isDeleted) {
          const msaipRequestReasonDrpdwn: SelectItem = {
            label: item.name,
            value: item.name
          };
          this.msaipRequestReasonDrpdwn.push(msaipRequestReasonDrpdwn);
          if (
            msaipRequestReasonDrpdwn.label == 'Other' &&
            duplicateIndex == null
          ) {
            duplicateIndex = this.msaipRequestReasonDrpdwn.findIndex(
              p => p.label === 'Other'
            );
            this.msaipRequestReasonDrpdwn.splice(duplicateIndex, 1);
          }
        }
      }
    });
  }
}
